import React from "react";
import HorizontalBarComp from "./HorizontalBar.component";
import HelpTextComp from "../../components/helper/helptext.component";
import GoalProgressBar from "../../components/okr/okr_depend_components/goalProgressBar.component";
import { useTranslation } from 'react-i18next';
import { imgUrl } from '../../utils/url';

const ResultSpreadComp = (props: any) => {
  const {teamProgress, plotKeyColorMapping, directReporteeLists, cQuaterName} = props;
  const { t } = useTranslation();
  let empty = 0;
  let tProgress = teamProgress.orgResultDirectReporteeTeam.map((t) => {
    let team = directReporteeLists.find((teamData) => teamData.id == t.id);
    if(team){
      if(t.progress === null){
        empty += 1;
      }
      return {
        ...t,
        name: team.name,
        owner_name: team.owner_name
      }
    }else{
      return t;
    }
    
  })

    return (
      <>
        <div className="resultSpreadWrapper orgResultsCard">
          <div className="orgResultsCard_header">
            <div className="orgResultsCard_header_title">
                {`${t('Results Spread')}`}
            </div>
          </div>
          {/* <div className="header">
              <div className="org-result-overview_header">
                
              </div>
            </div> */}
          <div className="orgResultsCard_main">
            <section className="orgResultsCard_main_left resultVariance">
              <div className="section-header">
                  {`${t('Result variance in this organization')} (${teamProgress.numOfTeam - teamProgress.zeroProgressTeamCount} ${teamProgress.numOfTeam - teamProgress.zeroProgressTeamCount > 1 ? t("teams") : t("team")})`}
                  {/* <span className="helptextIcon icon icon-outline-help_outline-14px" title=></span> */}
                  <HelpTextComp>
                    {`${t('The spread of results between the highest performing teams and the lowest, and where the average sits relative to the best possible results across all functional teams and working groups within')} ${props.forData.userName}'s ${t('organization (excluding teams with 0% progress).')}`}
                  </HelpTextComp>
              </div>
              <div className="section-visuals">
                <div>
                  <div 
                  className="section-visuals_title popupLink highPerformingTeams" 
                  title={`${t('Average results for the')} ${teamProgress['top20'].count} ${teamProgress['top20'].count > 1 ? t("teams") : t("team")} ${t('that fall in the top 20% of results out of')} ${teamProgress.numOfTeam - teamProgress.zeroProgressTeamCount} ${teamProgress.numOfTeam - teamProgress.zeroProgressTeamCount > 1 ? t("teams") : t("team")}.`} 
                  onClick={(e) => props.openModal(e, {type: "top", title: "Teams in Top 20%"}, 0)}
                  style={{pointerEvents : !(teamProgress['top20'].count > 0) ? "none" : "inherit"}}
                  >
                    {t('Teams in top')} 20%
                  </div>
                  <div className="section-visuals_graph">
                    <GoalProgressBar
                    percentage={teamProgress['top20'].progress}
                    color={plotKeyColorMapping['top20']}
                    
                    style={{
                      width: "calc(100% - 50px)",
                      marginTop: "0px",
                      fontSize: 12,
                      lineHeight: "10px"
                    }}
                    />
                    {/* <HorizontalBarComp
                    dataInPercentage = {teamProgress['top20']}
                    fill = {plotKeyColorMapping['top20']}
                    textColor = "#8d8d8d"
                    tooltip = 'Average progress of top 20% of teams' //entry.groupName
                    type ='team'
                    /> */}
                  </div>
                </div>
                <div>
                  <div className="section-visuals_title">
                    {`${t('Average results')}`}
                  </div>
                  <div className="section-visuals_graph">
                  <GoalProgressBar
                    percentage={teamProgress.allTeams}
                    color={plotKeyColorMapping['bottom20']}
                    title={`${t('Average results for the')} ${teamProgress.numOfTeam - teamProgress.zeroProgressTeamCount} ${teamProgress.numOfTeam - teamProgress.zeroProgressTeamCount > 1 ? t("teams") : t("team")} ${t('that have made progress on their results')}`}
                    style={{
                      width: "calc(100% - 50px)",
                      marginTop: "0px",
                      fontSize: 12,
                      lineHeight: "10px"
                    }}
                    />
                    {/* <HorizontalBarComp
                    dataInPercentage = {teamProgress['bottom20']}
                    fill = {plotKeyColorMapping['bottom20']}
                    textColor = "#8d8d8d"
                    tooltip = 'Average progress of bottom 20% of teams' 
                    type ='team'
                    /> */}
                  </div>
                </div>
                <div>
                  <div 
                  className="section-visuals_title popupLink lowPerformingTeams" 
                  title={`${t('Average results for the')} ${teamProgress['bottom20'].count} ${teamProgress['bottom20'].count > 1 ? t("teams") : t("team")} ${t('that fall in the bottom 20% of results out of')} ${teamProgress.numOfTeam - teamProgress.zeroProgressTeamCount} ${teamProgress.numOfTeam - teamProgress.zeroProgressTeamCount > 1 ? t("teams") : t("team")}.`}
                  onClick={(e) => props.openModal(e, {type: "bottom", title: "Teams in Bottom 20%"}, 0)}
                  style={{pointerEvents : !(teamProgress['bottom20'].count > 0) ? "none" : "inherit"}}
                  >
                    {/* All {teamProgress['numOfTeam']} Teams */}
                    {t('Teams in bottom ')}20%
                  </div>
                  <div className="section-visuals_graph">
                  <GoalProgressBar
                    percentage={teamProgress['bottom20'].progress}
                    color={plotKeyColorMapping['allTeams']}
                    style={{
                      width: "calc(100% - 50px)",
                      marginTop: "0px",
                      fontSize: 12,
                      lineHeight: "10px"
                    }}
                    />
                    {/* <HorizontalBarComp
                    dataInPercentage = {teamProgress['allTeams']}
                    fill = {plotKeyColorMapping['allTeams']}
                    textColor = "#8d8d8d"
                    type ='team'
                    /> */}
                  </div>
                </div>
              </div>
              <div className="resultVariance_text">
                {t('Top teams do')} <b>{(teamProgress['top20'].progress> teamProgress['allTeams'] ? teamProgress['top20'].progress - teamProgress['allTeams']: 0)}% {t('better')}</b> {t('than the average and')} <b>{teamProgress['top20'].progress > teamProgress['bottom20'].progress ? teamProgress['top20'].progress - teamProgress['bottom20'].progress :0}% {t('better')}</b> {t('than the bottom teams.')}
              </div>
              
              <div className="resultVariance_text_0Progress">
                <div 
                className="popupLink zeroProgressTeams"
                style={{pointerEvents : !(teamProgress.zeroProgressTeamCount > 0) ? "none" : "inherit"}}
                onClick={(e) => props.openModal(e, {type: "zero", title: "Teams with 0% Progress"}, 0)}
                  >
                    <b style={{marginRight: 4}}>{teamProgress.zeroProgressTeamCount} {teamProgress.zeroProgressTeamCount > 1 ? "teams" : "team"}</b> {t('have made')} 0% {t('progress')}.
                </div>
              </div>

              <div className="resultVariance_text_100Progress">
                <div 
                className="popupLink zeroProgressTeams"
                style={{pointerEvents : !(teamProgress.hundredProgressTeamCount > 0) ? "none" : "inherit"}}
                onClick={(e) => props.openModal(e, {type: "hundred", title: "Teams with 100% Progress"}, 0)}
                  >
                    <b style={{marginRight: 4}}>{teamProgress.hundredProgressTeamCount} {teamProgress.hundredProgressTeamCount > 1 ? "teams" : "team"}</b>{t(' have made')} 100% {t('progress')}.
                </div>
              </div>
            </section>
            <section className="orgResultOverview orgResultsCard_main_right resultVariance" style={{position: empty === tProgress.length ? "relative" : "inherit"}}>
              <div className="section-header">
                  {`${t('Overall results for direct reports’ teams')} (${teamProgress.orgResultDirectReporteeTeam ? tProgress.length : 0 } ${teamProgress.orgResultDirectReporteeTeam && tProgress.length > 1 ? t("teams") : t("team")})`}
                  {/* <span className="helptextIcon icon icon-outline-help_outline-14px" title=></span> */}
                  <HelpTextComp popUpClass="leftAlign">
                    {`${t('Progress for the teams led by')} ${props.forData.userName}'s ${t('direct reports across all of their')} ${t('OKRs')}.`}
                  </HelpTextComp>
              </div>
              <div className="section-visuals">
                {
                  teamProgress.orgResultDirectReporteeTeam
                  ? <>
                    {
                      tProgress.map((team) => 
                      <div key={team.id}>
                        <div className="section-visuals_title fixedWidth" title={!team.progress && team.progress !== 0 ? `${team.name} ${t('team led by')} ${team.owner_name} ${t('does not have an aligned OKR')}` : `${team.name}` }>
                          <a href={`/wb/goal/teamGoal?teamId=${team.id}`} target="_blank" style={{color: "inherit"}}>
                            {team.name}
                          </a> 
                        </div>
                        <div className="section-visuals_graph">
                          {
                            team.progress !== null && team.progress >= 0 ?
                            <GoalProgressBar
                            percentage={team.progress}
                            color={plotKeyColorMapping['bottom20']}
                            title={`${t('Results')} ${cQuaterName} for  ${team.name} team led by ${team.owner_name}`}
                            style={{
                              width: "calc(100% - 50px)",
                              marginTop: "0px",
                              fontSize: 12,
                              lineHeight: "10px"
                            }}
                            />
                            : empty !== tProgress.length ? <span style={{float: "right", marginRight: "12px", fontSize: 12}}>N/A</span> : ""
                          }
                        </div>
                      </div>
                      )
                    }
                    {
                    empty === tProgress.length &&
                    <div className={`emptyVisual ${(window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/')  > -1) ? "IE": ""}`}>
                      <div>
                        <img src={imgUrl('/images/okr-empty.png')} alt={`${t('OKR')} Empty`}/>
                      </div>
                      <div className="cont">
                        {`${t('None of the teams have an OKR aligned to this Objective theme')}`}
                      </div>
                    </div>
                    }
                  </>
                  : null
                }
              </div>
            </section>
          </div>
        </div>
      </>
    );
}

export default ResultSpreadComp;
